<template lang="pug">
    Row
        Col(span="20")
            Table#formItemTable(
                border
                draggable
                :columns="formItem.formAppliedHeaders"
                :data="appliedRules"
                @on-drag-drop="onDragDrop(value, ...arguments)"
                :no-data-text="$t('main.tableNoDataText')"
                :no-filtered-data-text="$t('main.tableNoFilteredDataText')")
        Col(span="2" offset="2")
            Poptip(placement="top")
                Button {{$t("domainsetting.add")}}
                div(slot="content")
                    Table(:columns="formItem.formOptionsHeaders"
                    border
                    :data="removeDuplicateByKey(options, value, 'value')"
                    height="400")
</template>
<script>
import { queryParamsFieldsCompletion } from "@/libs/rcmTableFieldsFunction";

export default {
    props: ["formItem", "formData", "value"],
    data() {
        return {
            options: this.formItem.options,
            queryParamsFields: this.formItem.queryParamsFields,
            formValueList: []
        };
    },
    mounted() {
        if (this.isRemoteOptions) {
            // 在意的欄位中, 只要一人符合 queryIf 條件, 即可以在 mounted 時獲取選項
            // 亦即: 所有在意的欄位都不符合時, 則不能在 mounted 時獲取選項
            let hasSomeFieldsMatch = this.queryParamsFields.some(field =>
                field.queryIf(this.formData[field.fieldName])
            );
            let canGetOptions = this.queryParamsFields.length == 0 || hasSomeFieldsMatch;
            if (canGetOptions) this.getRemoteOption(this.queryParams);
        }
    },
    created() {
        this.queryParamsFields = queryParamsFieldsCompletion(this.queryParamsFields);

        // 監聽需要注意的欄位
        this.queryParamsFields.forEach(field => {
            let { fieldName, queryIf } = field;
            this.$watch(
                function() {
                    return this.formData[fieldName];
                },
                function(newVal, oldVal) {
                    // console.log(`${this.formItem.key}: ${fieldName} changed from ${oldVal} to ${newVal}`);
                    if (queryIf(newVal)) {
                        this.$emit("input", this.formItem.defaultVal);
                        this.getRemoteOption(this.queryParams);
                    }
                },
                { deep: true }
            );
        });
    },
    methods: {
        // table 特定用法
        onDragDrop(data, a, b) {
            data = data.splice(b, 1, ...data.splice(a, 1, data[b]));
        },
        // 兩個 array 依照 key 去除重複
        removeDuplicateByKey(arr1, arr2, key) {
            let filteredArray = arr1.filter(e => !arr2.map(x => x[key]).includes(e[key]));
            return filteredArray;
        },
        getDuplicateByKey(arr1, arr2, key) {
            let filteredArray = arr1.filter(e => arr2.map(x => x[key]).includes(e[key]));
            return filteredArray;
        },
        async getRemoteOption(queryParams) {
            this.options = await this.formItem.remoteOptions(queryParams);
        }
    },
    computed: {
        isRemoteOptions() {
            return typeof this.formItem.remoteOptions == "function";
        },
        queryParams() {
            let queryParams = {};
            this.queryParamsFields.forEach(field => {
                let { fieldName } = field;
                queryParams[fieldName] = this.formData[fieldName];
            });
            return queryParams;
        },
        appliedRules() {
            // this.value 為第一個參數, 順序才會以 this.value 的為主
            let selectedRules = this.getDuplicateByKey(this.value, this.options, "value");

            // filter 之後 value 會沒有 description, 此時再 map 回去
            selectedRules = selectedRules.map(rule => {
                // 找到 options 當中指定的rule, 取他的 description
                rule.description = this.options.find(x => x.value == rule.value).description;
                return rule;
            });
            return selectedRules;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/TableList.vue